import { DeleteOutlined, ExpandLess, ExpandMore } from '@mui/icons-material';
import { Box, Checkbox, CircularProgress, Collapse, Divider, List, ListItemButton, Typography } from '@mui/material';
import React, { useEffect, useState } from "react";

const RowCollapse = ({ Header, Detail, defaultOpen = false }) => {
  const [openDetail, setOpenDetail] = useState(defaultOpen);

  return <Box display='flex' flexDirection='column' width='100%' paddingX={1}>
    <ListItemButton onClick={() => setOpenDetail(!openDetail)} sx={{ justifyContent: 'space-between', padding: '0' }}>
      <Box display='flex' flexDirection='row' width='100%' alignItems='center'>
        <Typography display='flex' flexDirection='row' justifyContent='space-between' variant='subtitle2' width='100%' alignItems='center'>
          <Box display='flex' component='span' flexDirection='row' alignItems='center'>
            {/* <Typography variant='inherit'><span>{date}</span></Typography> */}
            {Header()}
          </Box>
        </Typography>
        {/* <ListItemText primary="Inbox" /> */}
        {openDetail ? <ExpandLess /> : <ExpandMore />}
      </Box>
    </ListItemButton>
    <List sx={{ width: '100%', padding: '0', margin: '0' }}>
      <Box sx={{ paddingX: 1 }}>
        <Collapse in={openDetail} timeout="auto" unmountOnExit>
          <Box display='flex' paddingX={0} margin={0}>
            {Detail()}
            {/* <Typography display='flex' flexDirection='row' justifyContent='space-between' variant='inherit' width='100%' alignItems='center'>
              <Box><Typography ><span>{`${sale.quantity_sold} - ${sale.article.name}`}</span></Typography></Box>
              <Box display='flex' flexDirection='row' alignItems='center'>
                <Typography ><span>{`$ ${ccyFormat(sale.prices_sold.sale_price * sale.quantity_sold)}`}</span></Typography>
                {!readonly && <ListItemButton onClick={() => handleItemChecked(sale, sales)}><DeleteOutlined sx={{ padding: 0 }} /></ListItemButton>}
              </Box>
            </Typography> */}
          </Box>
        </Collapse>
      </Box>
    </List>
  </Box>
}

export default RowCollapse;